import { render, staticRenderFns } from "./AuditLogView.vue?vue&type=template&id=20f8a5d5&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AuditLogView.vue?vue&type=script&lang=js&"
export * from "./AuditLogView.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogView.vue?vue&type=style&index=0&id=20f8a5d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8a5d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCardTitle,VDataTable,VFlex,VLayout,VSpacer})
